module.exports = __webpack_public_path__ + "img/emailotp.7cb2b3c4.jpg";